import {
  APP_MESSAGES_ERROR,
  checkStringValueNull,
  getAuxiliaryNavigation,
  getPrimaryNavigationId,
  HeaderFooterMachCore,
  TodayPanelAem,
  transformToMap
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  BOOK,
  MY_TRIPS,
  TODAY_PANEL
} from '../../models/constants/common/common.constants';
import { DEFAULT_ERROR_MESSAGE } from '../../models/constants/today/today-trip.constants';
import { TodaysTrip } from '../../models/interfaces/todays-trip/todays-trip.interface';

export const getViewTripDetailsOpenNewTab = (
  contentHeaderFooter: HeaderFooterMachCore
): boolean => {
  const todayPanelObject = getAuxiliaryNavigation(
    contentHeaderFooter,
    TODAY_PANEL
  ) as TodayPanelAem;
  return todayPanelObject &&
    todayPanelObject.viewTripDetailsOpenNewTab === 'false'
    ? false
    : true;
};

export const getFindAlternateOpenNewTab = (
  contentHeaderFooter: HeaderFooterMachCore
): boolean => {
  const todayPanelObject = getAuxiliaryNavigation(
    contentHeaderFooter,
    TODAY_PANEL
  ) as TodayPanelAem;
  return todayPanelObject &&
    todayPanelObject.findAlternateOpenNewTab === 'false'
    ? false
    : true;
};

export const getArrowFlightDetailsOpenNewTab = (
  contentHeaderFooter: HeaderFooterMachCore
): boolean => {
  const todayPanelObject = getAuxiliaryNavigation(
    contentHeaderFooter,
    TODAY_PANEL
  ) as TodayPanelAem;
  return todayPanelObject &&
    todayPanelObject.arrowFlightDetailsOpenNewTab === 'false'
    ? false
    : true;
};

export const getViewBoardingPassOpenNewTab = (
  contentHeaderFooter: HeaderFooterMachCore
): boolean => {
  const todayPanelObject = getAuxiliaryNavigation(
    contentHeaderFooter,
    TODAY_PANEL
  ) as TodayPanelAem;
  return todayPanelObject &&
    todayPanelObject.viewBoardingPassOpenNewTab === 'false'
    ? false
    : true;
};

export const getCheckInOpenNewTab = (
  contentHeaderFooter: HeaderFooterMachCore
): boolean => {
  const todayPanelObject = getAuxiliaryNavigation(
    contentHeaderFooter,
    TODAY_PANEL
  ) as TodayPanelAem;
  return todayPanelObject && todayPanelObject.checkinOpenNewTab === 'false'
    ? false
    : true;
};

export const getDisableViewLink = (todayTrip: TodaysTrip): boolean => {
  return todayTrip?.trip?.viewTripDetails === '#' ? true : false;
};

export const extractPathSegment = (todayTrip: TodaysTrip): string => {
  const parts = checkStringValueNull(todayTrip?.trip?.viewTripDetails).split(
    '?'
  );
  return parts[0].replace(/\/$/, '');
};

export const getTripLinkAction = (todayTrip: TodaysTrip): string => {
  return extractPathSegment(todayTrip);
};

export const getBookLabel = (
  contentHeaderFooter: HeaderFooterMachCore
): string => {
  const bookObject = getPrimaryNavigationId(contentHeaderFooter, BOOK);
  return bookObject?.label ?? '';
};

export const getMyTripsLabel = (
  contentHeaderFooter: HeaderFooterMachCore
): string => {
  const myTrips = getPrimaryNavigationId(contentHeaderFooter, MY_TRIPS);
  return myTrips?.label ?? '';
};

export const getErrorMessages = (
  error: APP_MESSAGES_ERROR,
  todayTrip: TodaysTrip
): { errorMessageTitle: string; errorMessageDescription: string } => {
  const errorMap = transformToMap(error);

  if (!errorMap) {
    return DEFAULT_ERROR_MESSAGE;
  }

  const iropMessage = todayTrip.trip.iropMessage || 'SYS_ERROR';

  const errorObject = errorMap.get(iropMessage) || DEFAULT_ERROR_MESSAGE;

  return {
    errorMessageTitle: replaceFlightStatusNumber(errorObject, todayTrip),
    errorMessageDescription: errorObject.errorMessageDescription
  };
};

export const replaceFlightStatusNumber = (
  errorObject: { errorMessageTitle: string; errorMessageDescription: string },
  todayTrip: TodaysTrip
): string => {
  if (
    errorObject &&
    errorObject.errorMessageTitle.includes('{{flightNumber}}')
  ) {
    return errorObject.errorMessageTitle.replace(
      '{{flightNumber}}',
      `${todayTrip.trip.mktCarrierCode} ${todayTrip.trip.mktFlightNumber}`
    );
  } else {
    return errorObject.errorMessageTitle;
  }
};
